import axios,{ AxiosResponse } from "axios";
import { ElMessage } from 'element-plus';
import {Md5} from 'ts-md5';


//创建 http 实例
const $http = axios.create({
    baseURL:process.env.VUE_APP_BASE_API,
    //baseURL:'http://localhost:20100',
    timeout:600000,
    //processData:false,
    headers:{
        "Content-Type":"application/json;charset=utf-8"
    }
})

//请求拦截
$http.interceptors.request.use(config =>{
    const token = localStorage.getItem('AuthorizationToken');
    const bearerToken = `Bearer ${token}`;
    if(config && config.headers){
        config.headers["Authorization"] = bearerToken;
    }
    return config;
});

$http.interceptors.response.use(
    (res: AxiosResponse<any>)=>{
        const code:number = res.data.Code;
        if(code!=200){
            ElMessage({
                showClose: false,
                message: res.data.Info,
                duration:6000,
                type:'error'
            })
            //ElMessage.error(res.data.Info);
            return Promise.reject(res.data.Info)
        }
        res.data = res.data.Data
        return res;
    },
    ()=>{
        ElMessage.error("网络请求发送错误");
    }
)

export default $http
